import { connect } from 'react-redux';
import {
  CodeBench,
  mapDispatchToCodeBenchProps
} from '@codametrix/shared-views';
import {
  getPrevOrNextCase,
  getWorkItemDetails,
  updateWorkItemDismissed
} from '../../actions/cases.action';
import { AmplifyCore, conditionalUtils, commonEnums, configurationUtils } from '@codametrix/ui-common';
import {
  getDemographicsPanelLocation,
  getDemographicsPanelVisibility
} from '../../core/preferences/preferences';

const { invoiceUtils } = AmplifyCore;

//state = CMx.ApplicationState but not exactly
export const mapStateToCodeBenchProps = function(
  state: any
): Accelerate.BenchStateData {
  const location_state = state?.router?.location?.state;
  const cursorAPIContext = location_state
    ? { ...location_state }
    : { ...AmplifyCore.state.capabilities.cursorAPIContext };

  const realState = state as CMx.ApplicationState;
  const coderConfig = realState.ampUI.coderConfig;

  // Use the utility function to filter source invoices
  const {
    filteredSourceInvoices,
  } = configurationUtils.filterSourceInvoices({
    coderConfig,
    sourceInvoices: realState.codeBench.sourceInvoices.sourceInvoices,
    activeItemArtifacts: realState.cases.activeItem.artifacts,
    tenantId: realState.ui.context.activeContext?.healthSystemTenantId || '',
    serviceLine: realState.ui.context.activeContext?.serviceLineName || ''
  });

  const suggestedCodesFromSourceInvoices = invoiceUtils.sourceInvoicesToCodeSourceList(
    filteredSourceInvoices,
    realState.codeBench.codeDescriptions || {}
  );

  const hasMultiCodeSetFeatures = conditionalUtils.capabilityValue(
    state.capabilities?.capabilities?.codeSourcesFeatures?.on
  );
  const suggestedCodes: CMxCommonApp.SuggestedCodes = {
    cpt: {
      ...realState.codeBench.suggestedCodes.cpt,
      codeSourceList: hasMultiCodeSetFeatures
        ? suggestedCodesFromSourceInvoices.cptSourceList
        : []
    },
    icd: {
      ...realState.codeBench.suggestedCodes.icd,
      codeSourceList: hasMultiCodeSetFeatures
        ? suggestedCodesFromSourceInvoices.icdSourceList
        : []
    },
    modifier: {
      ...realState.codeBench.suggestedCodes.modifier,
      codeSourceList: hasMultiCodeSetFeatures
        ? suggestedCodesFromSourceInvoices.modSourceList
        : []
    }
  };
  return {
    ...state.codeBench,
    ...state.ampUI,
    suggestedCodes,
    capabilities: state.capabilities,
    improvements: state.improvements,
    caseEdits: state.caseEdits?.caseEdits,
    cursorAPIContext,
    htmlNotes: state?.cases?.htmlNotes ?? state?.codeBench?.htmlNotes,
    roles: state?.cases?.roles ?? [],
    caseRun: state?.cases?.activeItem,
    caseAccessTime: state?.codeBench?.caseAccessTime,
    customClaimsRelatedCases: state?.codeBench?.customClaimsRelatedCases,
    customClaimsRelatedCasesLoadState:
      state?.codeBench?.customClaimsRelatedCasesLoadState,
    backToWorklistPath: state.ui.backToWorklistPath,
    propertyConfig: state?.codeBench?.propertyConfig,
    workItem: state?.cases?.workItem,
    sourceInvoices: {
      sourceInvoices: filteredSourceInvoices
    }
  };
};

export const mapUpdatedStateToCodeBenchProps = (
  state: CMx.ApplicationState
) => {
  const values = mapStateToCodeBenchProps(state);

  const accountDefaults = state.accountSettings?.accountDefaults?.formObject;
  const demographicsPanelLocation = accountDefaults?.demographicsPanelLocation || 'right';
  const demographicsPanelVisibility = accountDefaults?.demographicsPanelVisibility || 'open';

  return {
    ...values,
    loadAlwaysFromURL: true,
    demographicsPanelLocation,
    demographicsPanelVisibility
  };
};

export const mapUpdatedDispatchToCodeBenchProps = (
  dispatch: any
): Accelerate.CodeBenchPanelMethods => {
  const values = mapDispatchToCodeBenchProps(dispatch);
  return {
    ...values,
    onCursorAction: async (cursorAPIPayload: CMxCommonApp.CursorAPIPayload) => {
      dispatch(getPrevOrNextCase(cursorAPIPayload));
    },
    loadWorkItemDetails: async (case_uid: string, caserun_uid: string) => {
      dispatch(
        getWorkItemDetails({
          case_uid,
          caserun_uid
        })
      );
    },
    updateWorkItemDismissed: async (workItemId: string, dismissed: boolean) => {
      dispatch(updateWorkItemDismissed({ workItemId, dismissed }));
    }
  };
};

export const ConnectedCodeBench = connect<
  Accelerate.BenchStateData,
  Accelerate.CodeBenchPanelMethods
>(
  //@ts-ignore Code Bench from amplify props do not exactly line up
  mapUpdatedStateToCodeBenchProps,
  mapUpdatedDispatchToCodeBenchProps
  //@ts-ignore
)(CodeBench);
